import { globalVars } from "../globalVariables";
import { settings, settingsCategories } from "../settings";
import { BuffUtils } from "../utils/buff";
import { styles } from "../styles";
import { drawCategoryHeaders } from "../settings/html/drawCategoryHeaders";
import { drawOption } from "../settings/html/drawOption";
import { beautifyName } from "../utils/beautifyName";
const addCustomSettings = () => {
    if (!l("menu")?.childNodes?.length)
        return;
    if (Game.onMenu !== "prefs")
        return;
    const settingsEl = document.createElement("div");
    settingsEl.id = `${process.env.APP_NAME}ModSettings`;
    settingsEl.className = "subsection";
    const settingsTitle = document.createElement("div");
    settingsTitle.className = "title";
    const titleContent = document.createElement("span");
    titleContent.style.cssText = "display:inline-flex;align-items:center;gap:12px;";
    const titleLabel = document.createElement("span");
    titleLabel.textContent = `${beautifyName(process.env.APP_NAME)} Settings`;
    titleContent.appendChild(titleLabel);
    const collapseButton = document.createElement("a");
    collapseButton.className = "smallFancyButton";
    collapseButton.href = "#";
    collapseButton.style.cssText = "flex-shrink:0;white-space:nowrap;";
    titleContent.appendChild(collapseButton);
    settingsTitle.appendChild(titleContent);
    const settingsListing = document.createElement("div");
    settingsListing.className = "listing";
    settingsListing.id = `${process.env.APP_NAME}SettingsListing`;
    collapseButton.setAttribute("aria-controls", settingsListing.id);
    const updateCollapsedState = () => {
        settingsListing.hidden = settings.collapseSettings;
        collapseButton.textContent = settings.collapseSettings ? "Expand" : "Collapse";
        collapseButton.setAttribute("aria-expanded", String(!settings.collapseSettings));
    };
    collapseButton.onclick = (event) => {
        event.preventDefault();
        settings.collapseSettings = !settings.collapseSettings;
        updateCollapsedState();
    };
    updateCollapsedState();
    settingsCategories.forEach((category, index) => {
        drawCategoryHeaders(settingsListing, category.title, index === 0);
        category.options.forEach((settingsOption) => {
            drawOption(settingsListing, settingsOption);
        });
    });
    settingsEl.appendChild(settingsTitle);
    settingsEl.appendChild(settingsListing);
    l("menu")?.insertBefore(settingsEl, l("menu")?.childNodes[3] || null);
};
export const replaceNativeHandlers = () => {
    const initUpdateMenu = Game.UpdateMenu;
    Game.UpdateMenu = () => {
        initUpdateMenu();
        addCustomSettings();
    };
    const initLoadSave = Game.LoadSave;
    Game.LoadSave = (data) => {
        BuffUtils.clearTimers();
        return initLoadSave(data);
    };
    const gainBuff = Game.gainBuff;
    Game.gainBuff = (...args) => {
        const oldBuffTimers = globalVars.buffTimers;
        const buff = gainBuff(...args);
        if (settings.highlightExistingBuffs) {
            BuffUtils.highlightExistingBuff(oldBuffTimers, buff);
        }
        return buff;
    };
    const QTStyles = document.createElement("style");
    QTStyles.id = "QTStyles";
    QTStyles.innerHTML = styles;
    document.head.appendChild(QTStyles);
};
